import React from "react";
import style from "./Header.module.css";
import Top from "./Top/Top";
import SwitchAndSelect from "./SwitchAndSelect/SwitchAndSelect";

const Header: React.FC = () => {

  return (
    <div className={style.Content}>
      <Top />
        <SwitchAndSelect />
    </div>
  );
};
export default Header;
